/**
 * Filename labels for supported DNA uploads, not proof of file contents.
 * Keep compound suffixes before shorter ones. No browser or Node dependencies.
 */
export const DNA_FILENAME_MEDIA_TYPES = [
  [".vcf.gz", "application/gzip"],
  [".zip", "application/zip"],
  [".vcf", "text/vcf"],
  [".txt", "text/plain"],
  [".csv", "text/csv"],
] as const;

export type DnaMediaType = (typeof DNA_FILENAME_MEDIA_TYPES)[number][1];

export function canonicalDnaMediaType(fileName: string): DnaMediaType | null {
  const lowerName = fileName.toLowerCase();
  return DNA_FILENAME_MEDIA_TYPES.find(([suffix]) => lowerName.endsWith(suffix))?.[1] ?? null;
}
